<script>
	import { page } from '$app/stores';

	let user = $page.data?.user;
</script>

<div class="capitalize font-bold text-base space-x-1">
	<span>{user?.identity?.firstName}</span>
	<span
		>{user?.identity?.commonName
			? user?.identity?.commonName?.slice(0, 1)
			: user?.identity?.lastName?.slice(0, 1)}.</span
	>
	<span>
		{#if !!user?.legalPerson?.name}
			({user?.legalPerson?.name})
		{/if}</span
	>
</div>
<div>{user?.email}</div>
